var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import './LegendGraph.styles.scss';
export var legendWrapperStyle = function (_a) {
    var layout = _a.layout, verticalAlign = _a.verticalAlign;
    var style;
    if (verticalAlign === 'bottom') {
        style = { bottom: 0 };
    }
    else if (verticalAlign === 'top') {
        style = { top: 0 };
    }
    if (layout === 'vertical') {
        style = __assign(__assign({}, style), { marginRight: -40, marginLeft: -40 });
    }
    return style;
};
var LegendGraph = function (_a) {
    var payload = _a.payload, _b = _a.layout, layout = _b === void 0 ? 'horizontal' : _b, _c = _a.align, align = _c === void 0 ? 'center' : _c, _d = _a.verticalAlign, verticalAlign = _d === void 0 ? 'bottom' : _d;
    return (_jsx("div", __assign({ className: "hefesto-legend-graph" }, { children: _jsx("div", __assign({ className: "\n\t\t\t\trecharts-custom-legend \n\t\t\t\trecharts-custom-legend--".concat(layout, " \n\t\t\t\trecharts-custom-legend--").concat(align, "\n\t\t\t\trecharts-custom-legend--").concat(verticalAlign, "\n\t\t\t\t") }, { children: _jsx("ul", { children: payload &&
                    payload.map(function (entry, idx) { return (_jsxs("li", { children: [_jsx("span", { className: "dot", style: {
                                    background: entry.payload.style.stroke || entry.payload.style.fill,
                                } }), _jsx("span", __assign({ className: "label" }, { children: entry.value }))] }, "item-".concat(idx))); }) }) })) })));
};
export default LegendGraph;
